import React from "react";
import { Button, Space } from "antd";

import AIProcessingButtonFrame from "@/components/ui/AIProcessingButtonFrame";

import "./DialogPopupFooter.css";

function DialogPopupFooter({
  feedbackDialogOpen,
  regenerateLoading,
  setFeedbackDialogOpen,
  handleDelete,
  regenerateDialogOpen,
  handleRegenerateDialogClose,
  handleSectionRegeneration,
  sourceDialogOpen,
  setSourceDialogOpen,
  qualityCheckDialogOpen,
  setQualityCheckDialogOpen,
}) {
  return (
    <div className="dialog-popup-footer">
      {feedbackDialogOpen && (
        <>
          {!regenerateLoading && (
            <Button
              onClick={async () => {
                setFeedbackDialogOpen(false);
              }}
              className="dialog-popup-footer-cancel"
            >
              Cancel
            </Button>
          )}
          <Button
            className="dialog-popup-footer-button-submit"
            onClick={handleDelete}
            // disabled={feedbackDialogContent.feedback === ""}
          >
            Delete
          </Button>
        </>
      )}
      {regenerateDialogOpen && (
        <>
          {!regenerateLoading && (
            <Button onClick={handleRegenerateDialogClose} className="dialog-popup-footer-cancel">
              Cancel
            </Button>
          )}
          <AIProcessingButtonFrame active={regenerateLoading}>
            <Button
              className={`dialog-popup-footer-button-submit ai-processing-button${
                regenerateLoading ? " ai-processing-button--active" : ""
              }`}
              onClick={() => handleSectionRegeneration()}
              disabled={regenerateLoading}
            >
              <Space size={6}>
                <img
                  src="/assets/icon-32.png"
                  alt="Section Icon"
                  style={{ width: "20px", height: "20px" }}
                />
                <span className={regenerateLoading ? "ai-processing-label" : undefined}>
                  {regenerateLoading ? "Regenerating..." : "Regenerate"}
                </span>
              </Space>
            </Button>
          </AIProcessingButtonFrame>
        </>
      )}
      {sourceDialogOpen && (
        <Button
          onClick={async () => {
            setSourceDialogOpen(false);
          }}
          className="dialog-popup-footer-cancel"
        >
          Close
        </Button>
      )}
      {qualityCheckDialogOpen && (
        <Button
          onClick={async () => {
            setQualityCheckDialogOpen(false);
          }}
          className="dialog-popup-footer-cancel"
        >
          Close
        </Button>
      )}
    </div>
  );
}

export default DialogPopupFooter;
